import React from 'react'

function EqualHousingOpportunity () {
    return (
        <div>
            <img src="https://21078790.fs1.hubspotusercontent-na1.net/hubfs/21078790/1click/equal-housing-opportunity-logo.png" alt="Equal Housing Opportunity Logo" style={{ width: '4rem', height: 'auto' }} />
            <div>
                NMLS #2229, NMLS Consumer Access website: www.nmlsconsumeraccess.org. We are pledged to the letter and spirit of U.S. policy for the achievement of equal housing opportunity throughout the Nation. We encourage and support an affirmative advertising and marketing program in which there are no barriers to obtaining housing because of race, color, religion, sex, handicap, familial status, or national origin.
            </div>
        </div>
    )
}

export default EqualHousingOpportunity;